import loadable from "@loadable/component";
import wrapperHOC from "@Utils/wrapperHOC";
import { getUtmParams } from "./utils";
import { useLocation } from "react-router";
import useWhitelabel from "hooks/useWhitelabel";
import PartnerReferSectionWrapper from "./PartnerReferSectionWrapper";

const PartnerReferSectionIndex = loadable(() => import("./PartnerReferSectionWrapper"), {
  fallback: <></>,
});

const PartnerReferSectionLoadable = () => {
  const { isWhitelabel } = useWhitelabel();
  const location = useLocation();
  const locationParams = new URLSearchParams(location.search);
  const { utmSource, utmMedium, campaign } = getUtmParams(locationParams);

  return isWhitelabel ? (
    <PartnerReferSectionWrapper />
  ) : (
    <>{campaign === "partner" && utmSource && utmMedium && <PartnerReferSectionIndex />}</>
  );
};

export default wrapperHOC(PartnerReferSectionLoadable, {
  componentName: "PartnerReferSectionLoadable-Home",
  showForChina: true,
});
